export default __webpack_public_path__ + "static/media/932.ec90dc62.png";